import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import LoadingSpinner from 'components/loading_spinner';
import DealsTable from 'bundles/apex/deals/table';
import { orderedColumns } from './config';
import { loadRelatedDeals } from 'bundles/apex/deals/show/store/related_deals/actions';

export function RelatedDeals({ deals, loading, loadRelatedDeals }) {
  useEffect(() => {
    loadRelatedDeals();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return <>
    <h5 className="mb-5">Other deals at this property</h5>
    {deals.length > 0
      ? <DealsTable deals={deals} orderedColumns={orderedColumns} />
      : <h6>No deals found.</h6>
    }
  </>;
}

RelatedDeals.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.shape({
    dealTypeLabel: PropTypes.string.isRequired,
  })),
  loading: PropTypes.bool,
  loadRelatedDeals: PropTypes.func.isRequired,
};

const mapStateToProps = ({ relatedDeals }) => ({
  deals: relatedDeals.otherPropertyDeals,
  loading: relatedDeals.loading,
});

const mapDispatchToProps = {
  loadRelatedDeals,
};

export default connect(mapStateToProps, mapDispatchToProps)(RelatedDeals);
